import TrainingSession from '../session';

/**
 * Create the action
 */

const { thunk, request, success, error } = TrainingSession.destroy(({ trainingId, sessionId }, fetch) => {
    return fetch.delete(`/trainings/${trainingId}/sessions/${sessionId}`);
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };